

(function () {
    angular.module('st').controller('PaginationController', ['$scope', function ($scope) {
        $scope.currentPage = 1;
        $scope.customItems = [];
        $scope.pageSize = 10;

        $scope.init = function (items) {
            $scope.customItems = items;
        }

        $scope.pageChangeHandler = function (num) {
            console.log('page changed to ' + num);
        };
    }]);
    angular.module('st').controller('OtherController', ['$scope', function ($scope) {
        $scope.pageChangeHandler = function (num) {
            console.log('going to page ' + num);
        };
    }]);
})();
